import { videoLengthLimitSec } from '../videos.constants';
import { VideoType } from '../videos.domain';

export const getMediaFileName = (name: string) => {
  const temp = name.split('.');
  const newName = temp.slice(0, temp.length - 1);
  return newName.join('.');
};

type ValidateVideoProps = {
  duration: number;
  fileSize: number;
  videoWidth: number;
  videoHeight: number;
  videoType: VideoType;
};
const validateShortVideo = (p: ValidateVideoProps): ValidationMessage => {
  if (p.videoWidth >= p.videoHeight) {
    return {
      text: 'The video format is not supported. Exercise videos have to be made in portrait mode.',
      type: 'error',
    };
  }

  if (p.duration > videoLengthLimitSec) {
    return {
      text: 'Your video file is longer than 90s. Exercise videos have to be up to 90 sec. Trim the video or upload new one.',
      type: 'error',
    };
  }
};
const validateLongVideo = (p: ValidateVideoProps): ValidationMessage => {
  if (p.duration < videoLengthLimitSec) {
    return { text: 'Long video should be more than 90s', type: 'error' };
  }
  if (p.duration < videoLengthLimitSec) {
    return { text: 'Horizontal video should be more than 90s', type: 'error' };
  }
};

export type ValidationMessage =
  | { text: string; type: 'warning' | 'error' }
  | undefined;

export const validateVideo = (p: ValidateVideoProps): ValidationMessage => {
  if (p.videoType === 'short') {
    return validateShortVideo(p);
  }
  return validateLongVideo(p);
};
